"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _ArrowBackRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackRounded"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead/TableHead"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody/TableBody"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _theme = require("../../../theme");
var _MessageCard = _interopRequireDefault(require("../../../components/Cards/MessageCard"));
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _PlanDesignForm = _interopRequireDefault(require("./PlanDesignForm"));
var _ContentBlock = _interopRequireDefault(require("../../../components/Divs/ContentBlock"));
var _HeaderDiv = _interopRequireDefault(require("../../../components/HeaderDiv"));
var _StyledTable = _interopRequireDefault(require("../../../components/StyledTable"));
var _StyledTableRow = _interopRequireDefault(require("../../../components/StyledTableRow"));
var _StyledTableCell = _interopRequireDefault(require("../../../components/StyledTableCell"));
var _Loader = _interopRequireDefault(require("../../../components/Loader"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Revisions = /*#__PURE__*/function (_Component) {
  function Revisions() {
    var _this;
    (0, _classCallCheck2["default"])(this, Revisions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Revisions, [].concat(args)), _this.state = {
      revisions: [],
      selectedRevision: null
    }, _this._selectRevision = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(revisionID) {
        var selectedRevision;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getSinglePlanDesignRevision(revisionID);
            case 2:
              selectedRevision = _context.sent;
              _this.setState({
                selectedRevision: selectedRevision
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this._revertToRevision = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var data;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            delete _this.state.selectedRevision.changedBy;
            delete _this.state.selectedRevision.effectiveDate;
            delete _this.state.selectedRevision.revisionID;
            data = _objectSpread(_objectSpread({}, _this.props.designs[_this.props.selectedClassID][_this.props.selectedDesignID]), _this.state.selectedRevision); // TODO: if we don't want to actually save the revision to the current plan design, then remove this function call
            _context2.next = 6;
            return _this.props.saveDesign(data);
          case 6:
            _context2.next = 8;
            return _this.props.revertToRevision(_this.props.selectedClassID, _this.props.selectedDesignID, data);
          case 8:
            setTimeout(function () {}, 5000);
            _this.props.goBack();
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._handleGoBack = function () {
      if (_this.state.selectedRevision) {
        _this.setState({
          selectedRevision: null
        });
        return null;
      }
      return _this.props.goBack();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(Revisions, _Component);
  return (0, _createClass2["default"])(Revisions, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var revisions;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.props.getPlanDesignRevisions(this.props.selectedDesignID);
            case 2:
              revisions = _context3.sent;
              this.setState({
                revisions: revisions
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        whitelabel = _this$props.whitelabel,
        designs = _this$props.designs,
        selectedClassID = _this$props.selectedClassID,
        selectedDesignID = _this$props.selectedDesignID;
      var styles = {
        headerTitleBlock: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center'
        },
        backBtn: {
          minWidth: 30,
          padding: 2,
          marginRight: 5,
          marginLeft: -5
        },
        tableHeading: {
          paddingTop: 10,
          paddingBottom: 10,
          fontFamily: _theme.fonts.type.heading
        },
        tableCell: {
          paddingTop: 10,
          paddingBottom: 10,
          fontFamily: _theme.fonts.type.light
        }
      };
      if (this.props.loading) {
        return /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
          whitelabel: this.props.whitelabel
        });
      }
      ;
      return /*#__PURE__*/_react["default"].createElement(_ContentBlock["default"], null, /*#__PURE__*/_react["default"].createElement(_HeaderDiv["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.headerTitleBlock
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        style: styles.backBtn,
        onClick: this._handleGoBack,
        transparent: true
      }, /*#__PURE__*/_react["default"].createElement(_ArrowBackRounded["default"], null)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0"
      }, _i18n["default"].t(_tokens["default"].titles.revisions))), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].locale === "fr" ? designs[selectedClassID][selectedDesignID].title.replace("Design", "Conception") : designs[selectedClassID][selectedDesignID].title,
        isSelected: true,
        clickable: false
      })), this.state.selectedRevision ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.props.overrideModularView && /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.quotes.revisionReview, {
          revisionID: this.state.selectedRevision.revisionID
        }),
        subtitle: _i18n["default"].t(_tokens["default"].labels.quotes.passedRevisions),
        btn: !this.props.isMasterSite && this.props.currentAccountMeta.state > 3 ? null : _i18n["default"].t(_tokens["default"].buttons.revert),
        btnName: _i18n["default"].t(_tokens["default"].buttons.revert),
        btnOnClick: this._revertToRevision
      }), /*#__PURE__*/_react["default"].createElement(_PlanDesignForm["default"], {
        isMasterSite: this.props.isMasterSite,
        selectedDesignID: selectedDesignID,
        selectedClassID: selectedClassID,
        designs: designs,
        whitelabel: whitelabel,
        revision: this.state.selectedRevision
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.state.revisions || this.state.revisions.length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.quotes.noSavedRevisions)) : /*#__PURE__*/_react["default"].createElement(_StyledTable["default"], null, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_StyledTableRow["default"], null, /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
        style: styles.tableHeading
      }, _i18n["default"].t(_tokens["default"].labels.quotes.revisionID)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
        style: styles.tableHeading
      }, _i18n["default"].t(_tokens["default"].labels.quotes.design)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
        style: styles.tableHeading
      }, _i18n["default"].t(_tokens["default"].labels.quotes.changedBy)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
        style: styles.tableHeading
      }, _i18n["default"].t(_tokens["default"].labels.quotes.changedDate)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
        style: styles.tableHeading
      }))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, this.state.revisions.map(function (revision) {
        var changedBy = revision.changedByType;
        if (_i18n["default"].locale === 'fr') {
          if (changedBy === 'Advisor') {
            changedBy = 'Conseiller';
          }
          if (changedBy === 'Support') {
            changedBy = 'Soutien';
          }
        }
        return /*#__PURE__*/_react["default"].createElement(_StyledTableRow["default"], {
          key: revision.revisionID
        }, /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
          style: styles.tableCell
        }, revision.revisionID), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
          style: styles.tableCell
        }, _i18n["default"].locale === "fr" ? revision.title.replace("Design", "Conception") : revision.title), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
          style: styles.tableCell
        }, "".concat(revision.changedByName, " (").concat(changedBy, ")")), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
          style: styles.tableCell
        }, dates.getLocalDisplay(revision.effectiveDate, 'lll', _i18n["default"].locale)), /*#__PURE__*/_react["default"].createElement(_StyledTableCell["default"], {
          style: styles.tableCell
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          transparent: true,
          onClick: function onClick() {
            _this2._selectRevision(revision.revisionID);
          }
        }, _i18n["default"].t(_tokens["default"].buttons.view))));
      })))));
    }
  }]);
}(_react.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    loading: state.quotes.loading
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(Revisions);